import { render, staticRenderFns } from "./IbInfoModal.vue?vue&type=template&id=73f4346f&scoped=true"
import script from "./IbInfoModal.vue?vue&type=script&lang=js"
export * from "./IbInfoModal.vue?vue&type=script&lang=js"
import style0 from "./IbInfoModal.vue?vue&type=style&index=0&id=73f4346f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f4346f",
  null
  
)

export default component.exports